import Vue from 'vue'
import VuePageTitle from 'vue-page-title'
import App from './App.vue'
import router from './router'
import store from './store'
import NProgress from 'vue-nprogress'
import './registerServiceWorker'
import './global.scss'
import SocketHub from './socket-hub.js'
import SafeTreeview from 'vue-tree-view-table'
import PrimeVue from 'primevue/config'

// theme
import 'primevue/resources/themes/saga-blue/theme.css'
import 'primevue/resources/primevue.min.css'
import 'primeicons/primeicons.css'

import {
  Avatar,
  TreeSelect,
  Rate,
  Breadcrumb,
  InputNumber,
  Steps,
  Message,
  Upload,
  Button,
  Layout,
  Table,
  Icon,
  Progress,
  Radio,
  Dropdown,
  Menu,
  Carousel,
  Input,
  Calendar,
  Badge,
  Slider,
  Form,
  Tooltip,
  Select,
  Switch,
  Tag,
  Affix,
  Spin,
  Alert,
  Checkbox,
  Tabs,
  Pagination,
  notification,
  Drawer,
  Card,
  Row,
  Col,
  Divider,
  Modal,
  FormModel,
  Popover,
  Collapse,
  Popconfirm,
  AutoComplete,
  Empty,
  DatePicker,
  PageHeader,
  Tree,
  Statistic,
  List,
  Space,
  Descriptions,
} from 'ant-design-vue'
import VueApexCharts from 'vue-apexcharts'
import VueNumericInput from 'vue-numeric-input'
import { LicenseManager } from 'ag-grid-enterprise'
import { ColorPicker, ColorPanel } from 'one-colorpicker'
import MaxNumberLength from './directives/max-number-length'
Vue.use(PrimeVue)
// app.component('TreeTable', TreeTable);
// app.component('Column', Column);
Vue.use(SafeTreeview)
Vue.use(Tree)
Vue.use(Collapse)
Vue.use(DatePicker)
Vue.use(AutoComplete)
Vue.use(Modal)
Vue.use(Row)
Vue.use(Col)
Vue.use(Avatar)
Vue.use(Card)
Vue.use(Button)
Vue.use(Rate)
Vue.use(TreeSelect)
Vue.use(Breadcrumb)
Vue.use(Layout)
Vue.use(Table)
Vue.use(Icon)
Vue.use(Progress)
Vue.use(Radio)
Vue.use(Dropdown)
Vue.use(Menu)
Vue.use(Carousel)
Vue.use(Input)
Vue.use(Calendar)
Vue.use(Badge)
Vue.use(Slider)
Vue.use(Form)
Vue.use(Tooltip)
Vue.use(Select)
Vue.use(Tag)
Vue.use(Affix)
Vue.use(Spin)
Vue.use(Alert)
Vue.use(Checkbox)
Vue.use(Tabs)
Vue.use(Pagination)
Vue.use(Upload)
Vue.use(Message)
Vue.use(Steps)
Vue.use(InputNumber)
Vue.use(Drawer)
Vue.use(Switch)
Vue.use(notification)
Vue.use(Divider)
Vue.use(FormModel)
Vue.use(Popover)
Vue.use(Popconfirm)
Vue.use(AutoComplete)
Vue.use(SocketHub)
Vue.use(Empty)
Vue.use(PageHeader)
Vue.use(VueApexCharts)
Vue.use(VueNumericInput)
Vue.use(Statistic)
Vue.use(List)
Vue.use(Space)
Vue.use(ColorPanel)
Vue.use(ColorPicker)
Vue.use(Descriptions)

Vue.prototype.$notification = notification
Vue.prototype.$confirm = Modal.confirm
Vue.prototype.$info = Modal.info

Vue.directive('max-number-length', MaxNumberLength)

Vue.use(NProgress)
Vue.use(VuePageTitle, {
  prefix: 'KBKG | ',
  router,
})

const { VUE_APP_AG_GRID_LISCENCE_KEY } = process.env
LicenseManager.setLicenseKey(VUE_APP_AG_GRID_LISCENCE_KEY)

Vue.config.productionTip = false
const nprogress = new NProgress({ parent: 'body' })

new Vue({
  router,
  store,
  nprogress,
  render: h => h(App),
}).$mount('#app')
